import * as cartTypes from "../ActionTypes";

export function addToCart(data) {
  return {
    type: cartTypes.ADD_TO_CART,
    data,
  };
}
